import { render, staticRenderFns } from "./ValkyrieListDefaultHeader.vue?vue&type=template&id=304d05fa&"
import script from "./ValkyrieListDefaultHeader.vue?vue&type=script&lang=js&"
export * from "./ValkyrieListDefaultHeader.vue?vue&type=script&lang=js&"
import style0 from "./ValkyrieListDefaultHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSkeletonLoader,VSpacer})
